import styled, { CSSProp } from 'styled-components'

export const Relative = styled.div`
  position: relative;
`

export const Absolute = styled.div<{ positionCSS?: CSSProp }>`
  position: absolute;
  z-index: 2;
  ${({ positionCSS }) => positionCSS};
`



// WEBPACK FOOTER //
// ./src/components/Overlay/styles.ts